import axios from '@/lib/axios';
import SignInParams from '@/features/facility/auth/types/SignInParams';

const signIn = (data: SignInParams) => {
  return axios.post('/facility/sign_in', data);
}

export default signIn;